module.exports = __webpack_public_path__ + "static/assets/6aab923ab87e1998c1e7fefb2b3c9829.png";